import React from 'react';
import './SignIn.css'
import authClient from './../auth/Auth';
import google from './google-icon.png';

class SignIn extends React.Component {
    render() {
        return (

            <div className="SignIn">
                <div className="SignIn-container">
                    <button type="button" className="btn btn-outline-primary" onClick={authClient.signIn}>
                        <span><img className="SignIn-img" alt="" src={google} /></span><b>Sign in with Google</b>
                    </button>
                </div>
            </div>
        );
    }
}

export default SignIn;